// extracted by mini-css-extract-plugin
export default {"landingComponent":"Landing_landingComponent__OxdFo","landing":"Landing_landing__z0vW8"};